import { ResourceLibItem } from '../../../xstate/prostudio.xstate.types';

/** A Resource Library entry matches when its name or description holds the query. */
export const matchesLibrarySearch = (
  item: Pick<ResourceLibItem, 'name' | 'description'>,
  query: string
): boolean => {
  const term = query.trim().toLowerCase();
  if (!term) return true;
  return (
    (item.name ?? '').toLowerCase().includes(term) ||
    (item.description ?? '').toLowerCase().includes(term)
  );
};
